<template>
  <v-dialog v-model="dialog" persistent max-width="800px">
    <v-card>
      <v-card-title class="redColor d-flex text-white">
        <span class="headline">
          {{ $t("leko_employees.car_part_groups.select_parts") }}
        </span>
        <v-spacer></v-spacer>
        <v-btn variant="outlined" icon color="white" @click="close">
          <v-icon x-large> mdi-close </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row row wrap>
          <!--SELECT-->
          <v-col cols="12" xs="12" md="12" lg="12">
            <v-autocomplete
              v-model="part"
              v-model:search="searchPart"
              :loading="loadingSearch"
              :items="parts"
              :label="$t('leko_employees.car_part_groups.search_part')"
              :item-title="`title.${$store.getters.language}`"
              text
              color="red-darken-1"
              append-icon="mdi-plus"
              single-line
              hide-details
              hide-no-data
              return-object
              @keyup.enter="addPart()"
              @click:append="addPart()"
            />
          </v-col>
          <!--LIST-->
          <v-col cols="12" xs="12" md="12" lg="12" mt-4>
            <v-row v-if="loading" align-center justify-center>
              <v-progress-circular :size="50" color="red" indeterminate />
            </v-row>

            <v-list v-else>
              <v-toolbar color="red-darken-1" flat>
                <v-toolbar-title>
                  {{ $t("leko_employees.car_part_groups.position") }}:
                  {{
                    $t(`leko_employees.car_part_groups.position_${position}`)
                  }}
                </v-toolbar-title>
              </v-toolbar>

              <v-list-item
                v-for="(item, index) in items"
                :key="item._id"
                color="grey-darken-4"
              >
                <v-row
                  class="d-flex justify-between px-2"
                  :class="index % 2 == 0 ? 'bg-grey-lighten-3' : ''"
                >
                  <v-col cols="11">
                    <span class="pt-1">{{
                      item.title[$store.getters.language]
                    }}</span>
                  </v-col>
                  <v-col cols="1">
                    <v-btn
                      icon
                      color="red-darken-1"
                      variant="text"
                      @click.stop="removePart(item._id)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="red-darken-1" variant="outlined" @click="close">
          {{ $t("leko_employees.car_part_groups.close") }}
        </v-btn>
        <v-btn
          :loading="loadingSave"
          :disabled="items.length < 1"
          color="green darken-1"
          variant="outlined"
          @click="save"
        >
          {{ $t("leko_employees.car_part_groups.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import getRequest from "../../api/getRequest";
import putRequest from "../../api/putRequest";

export default {
  data: () => ({
    dialog: false,
    loading: false,
    loadingSearch: false,
    loadingSave: false,
    position: null,
    searchPart: null,
    part: null,
    parts: [],
    items: [],
  }),
  watch: {
    searchPart(value) {
      if (value) {
        this.loadingSearch = true;
        getRequest(
          "/info-car/parts",
          `title=${value}&language=${this.$store.getters.language}`,
        )
          .then((response) => {
            this.parts = response.parts;
          })
          .catch(() => {})
          .finally(() => {
            this.loadingSearch = false;
          });
      }
    },
  },
  mounted() {},
  methods: {
    open(position) {
      this.dialog = true;
      this.loading = true;
      this.position = position;
      getRequest("/part-groups/", `position=${this.position}`)
        .then((response) => {
          if (response && response.parts) this.items = response.parts;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.position = null;
      this.searchPart = null;
      this.part = null;
      this.parts = [];
      this.items = [];
      this.dialog = false;
    },
    addPart() {
      this.items.push(this.part);
      this.part = null;
      this.searchPart = null;
      this.parts = [];
    },
    removePart(id) {
      const index = this.items.findIndex(
        (i) => i._id.toString() === id.toString(),
      );
      if (index > -1) this.items.splice(index, 1);
    },
    save() {
      this.loadingSave = true;
      putRequest("/part-groups/", `position=${this.position}`, {
        items: this.items,
      })
        .then(() => {})
        .catch(() => {})
        .finally(() => {
          this.loadingSave = false;
          this.close();
        });
    },
  },
};
</script>
